import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

type Props = CellProps

const DateCell: FC<Props> = ({ title }) => {
  return <div className='custom-cell'>{title?.split('.')[0]?.split('T').join(' ') || ''}</div>
}

export default DateCell
